<template>
  <div class="row mx-0 mb-2 p-2 bg-white shadow" @contextmenu.prevent="openContextMenu">
    <div class="col-4 my-auto fw-bold" :title="vorlage.name">{{ vorlage.name }}</div>
    <div class="col-4 my-auto" :title="vorlage.titel">{{ vorlage.titel }}</div>
    <div class="col-2 my-auto">
      <span v-for="gruppe in gruppen" :key="gruppe" class="badge text-bg-primary me-1 mb-1">{{ gruppe }}</span>
    </div>
    <!-- <div class="col-1 my-auto">{{ vorlage.vorlageTextbausteine?.length }}</div> -->
    <div class="col-1 my-auto">{{ vorlage.type == 0 ? 'Neuvertrag' : 'Nachtrag' }}</div>
    <div class="col-1 my-auto d-flex justify-content-end">
      <router-link :to="{ name: 'DetailsVorlage', params: { vorlageid: vorlage.id.toString() } }" class="btn btn-primary btn-sm">
        <div v-if="loading && thisLoading" class="spinner-border spinner-border-sm" role="status">
          <span class="visually-hidden">Loading...</span>
        </div>

        <font-awesome-icon v-else icon="magnifying-glass-plus" />
      </router-link>
    </div>
  </div>

  <!-- Context Menu -->
  <div v-if="showMenu" :style="{ top: `${menuPosition.y}px`, left: `${menuPosition.x}px` }" class="dropdown-menu show" ref="contextMenu">
    <li class="dropdown-item context-menu-item" @click="duplicateVorlage()"><font-awesome-icon icon="clone" /> Vorlage duplizieren</li>
  </div>
</template>

<script lang="ts" setup>
  //#region Imports
  import { PropType, ref, computed, onBeforeUnmount } from 'vue';
  import { useStore } from 'vuex';

  import { ActionTypes as VorlageActionTypes } from '@/store/modules/Vorlagen/actions';

  import { Vorlage, VorlageItem } from '@/models/VorlageModels';
  //#endregion
  const props = defineProps({
    vorlage: {
      type: Object as PropType<Vorlage | VorlageItem>,
      required: true,
    },
  });

  const emit = defineEmits(['reload-page']);

  const store = useStore();

  const thisLoading = ref(false);
  const loading = computed(() => store.getters.status.createVorlageLoading);

  const gruppen = computed(() => {
    const uniqueGruppen = new Array<string>();

    const gruppen = props.vorlage.gruppe?.split(';');

    gruppen.forEach((gruppe) => {
      const trimmedGruppe = gruppe.trim();
      if (trimmedGruppe !== '' && !uniqueGruppen.includes(trimmedGruppe)) {
        uniqueGruppen.push(trimmedGruppe);
      }
    });

    return uniqueGruppen.sort();
  });

  const showMenu = ref(false);
  const menuPosition = ref({ x: 0, y: 0 });

  function openContextMenu(event: MouseEvent) {
    event.preventDefault();
    menuPosition.value = { x: event.clientX, y: event.clientY };
    showMenu.value = true;
    document.addEventListener('click', closeContextMenu);
  }

  function closeContextMenu() {
    showMenu.value = false;
    document.removeEventListener('click', closeContextMenu);
  }

  async function duplicateVorlage() {
    thisLoading.value = true;

    await store.dispatch(VorlageActionTypes.GetVorlageById, props.vorlage.id);
    const vorlageTemplate = store.getters.vorlagen.find((v: Vorlage) => v.id == props.vorlage.id);

    const duplicate = JSON.parse(JSON.stringify(vorlageTemplate)) as Vorlage;

    duplicate.id = 0;
    duplicate.name += ' (Kopie)';

    for (var textbaustein of duplicate.vorlageTextbausteine) {
      textbaustein.id = 0;
      textbaustein.vorlageid = 0;

      for (var abschnittRegel of textbaustein.abschnittRegeln) {
        abschnittRegel.id = 0;
        abschnittRegel.vorlageTextbausteinId = 0;

        for (var regel of abschnittRegel.regeln) {
          regel.id = 0;
          regel.vorlageAbschnittRegelId = 0;
        }
      }
    }

    store.dispatch(VorlageActionTypes.CreateVorlage, duplicate).then(() => {
      thisLoading.value = false;
      emit('reload-page');
    });
  }

  onBeforeUnmount(() => {
    document.removeEventListener('click', closeContextMenu);
    document.removeEventListener('contextmenu', closeContextMenu);
  });
</script>

<style scoped>
  .context-menu-item {
    cursor: pointer;
  }

  .cut-text {
    overflow: hidden;
    white-space: nowrap; /* Don't forget this one */
    text-overflow: ellipsis;
  }
</style>
